// extracted by mini-css-extract-plugin
export default {"blog_container":"Blog_blog_container__se2g6","blog_links":"Blog_blog_links__qzAGc","blog_post":"Blog_blog_post__UWnQQ"};